import { jsx as _jsx } from "react/jsx-runtime";
import { toClassName } from '../../utils/ClassNameUtils.js';
import { Button } from '../Button/Button.js';
import { Icon } from '../Icon/Icon.js';
export const IconButton = ({ className, color, disabled, icon, size, toggled, onClick, onMouseDown, }) => {
    return (_jsx(Button, { className: className, color: color, onClick: onClick, onMouseDown: onMouseDown, disabled: disabled, children: _jsx(Icon, { className: toggled ? 'icon-toggled' : undefined, icon: icon, size: size }) }));
};
IconButton.displayName = 'IconButton';
IconButton.Group = ({ condensed, skipBottomMargin, children }) => {
    const className = toClassName('buttons', condensed && 'has-addons', skipBottomMargin && 'no-bottom-margin');
    return _jsx("div", { className: className, children: children });
};
IconButton.Group.displayName = 'IconButton.Group';
//# sourceMappingURL=IconButton.js.map